/* ==========================================================================
   Oakhold — cart layer
   AJAX add / change / render against the Cart and Section Rendering APIs.
   Routes and copy are injected by the layout (window.Oakhold.routes/strings)
   because Liquid is not evaluated inside asset JavaScript.
   ========================================================================== */
(function () {
  'use strict';

  var WL = (window.Oakhold = window.Oakhold || {});
  var routes = WL.routes || {};
  var S = WL.strings || {};

  /* core.js owns the Shopify money-format parser; fall back only if it is absent */
  function money(cents) {
    if (WL.formatMoney) return WL.formatMoney(cents);
    return '$' + (cents / 100).toFixed(2);
  }

  function setCount(count) {
    document.querySelectorAll('[data-oh-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('is-empty', count === 0);
    });
    document.querySelectorAll('[data-oh-cart-label]').forEach(function (el) {
      var tpl = S.cartAria || 'Cart, __WLN__ items';
      el.setAttribute('aria-label', tpl.replace('__WLN__', count));
    });
  }

  /* Re-render the drawer markup from the server so prices, discounts and
     line-item rules always come from Shopify rather than client guesses. */
  function refreshDrawer() {
    var drawer = document.querySelector('[data-oh-drawer="cart"]');
    if (!drawer) return Promise.resolve();
    var sectionId = drawer.getAttribute('data-oh-cart-section');
    if (!sectionId) return Promise.resolve();
    return fetch((routes.cart || '/cart') + '?section_id=' + sectionId, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-oh-cart-body]');
        var current = drawer.querySelector('[data-oh-cart-body]');
        if (fresh && current) {
          current.innerHTML = fresh.innerHTML;
          if (WL.init) WL.init(current);
        }
      })
      .catch(function () { /* drawer keeps its previous state */ });
  }

  function getCart() {
    return fetch((routes.cart || '/cart') + '.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); });
  }

  function syncCart() {
    return getCart().then(function (cart) {
      setCount(cart.item_count);
      document.querySelectorAll('[data-oh-cart-total]').forEach(function (el) {
        el.textContent = money(cart.total_price);
      });
      return cart;
    });
  }

  /* ------------------------------------------------------------- add --- */
  function bindAddForms(root) {
    (root || document).querySelectorAll('[data-oh-atc-form]').forEach(function (form) {
      if (form.dataset.wlAtcBound) return;
      form.dataset.wlAtcBound = '1';

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('[data-oh-atc-button]');
        var label = btn ? btn.querySelector('[data-oh-atc-label]') : null;
        var original = label ? label.textContent : '';
        var errorBox = form.querySelector('[data-oh-atc-error]');

        if (errorBox) { errorBox.textContent = ''; errorBox.hidden = true; }
        if (btn) btn.disabled = true;
        if (label) label.textContent = S.atcWorking || 'Adding…';

        var body = new FormData(form);
        fetch(routes.cartAdd || '/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: body
        })
          .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error((res.data && res.data.description) || (S.errorGeneric || 'Something broke on our side. Refresh and try again — your cart is safe.'));
            if (label) label.textContent = S.atcDone || 'Added ✓';
            return syncCart().then(refreshDrawer).then(function () {
              if (WL.openDrawer) WL.openDrawer('cart');
            });
          })
          .catch(function (err) {
            if (errorBox) { errorBox.textContent = err.message; errorBox.hidden = false; }
            if (label) label.textContent = original;
          })
          .then(function () {
            setTimeout(function () {
              if (btn) btn.disabled = false;
              if (label && label.textContent === (S.atcDone || 'Added ✓')) label.textContent = original;
            }, 1600);
          });
      });
    });
  }

  /* ---------------------------------------------------------- change --- */
  function changeLine(key, quantity) {
    return fetch(routes.cartChange || '/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        setCount(cart.item_count);
        return refreshDrawer();
      });
  }

  /* Delegated so re-rendered drawer markup needs no re-binding */
  document.addEventListener('click', function (e) {
    var remove = e.target.closest('[data-oh-cart-remove]');
    if (remove) {
      e.preventDefault();
      remove.disabled = true;
      changeLine(remove.getAttribute('data-oh-cart-remove'), 0);
      return;
    }
    var step = e.target.closest('[data-oh-cart-step]');
    if (step) {
      e.preventDefault();
      var key = step.getAttribute('data-oh-cart-key');
      var next = parseInt(step.getAttribute('data-oh-cart-step'), 10);
      if (!isNaN(next) && key) { step.disabled = true; changeLine(key, next); }
    }
  });

  WL.cart = { sync: syncCart, refreshDrawer: refreshDrawer, change: changeLine, bind: bindAddForms };

  function boot(root) { bindAddForms(root); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
